import React, { useEffect, useState } from 'react';

import { toast } from 'shared/toast';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  ModalFooter,
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage,
} from '@chakra-ui/react';

import { ModalRootProps } from 'components/Modal/Root';

type FormErrors = {
  [key: string]: string | boolean;
  type: 'invalid' | 'required';
};

interface ModalFlowStatusActionProps extends ModalRootProps {
  data: {
    description: string;
  };
}

const ModalFlowStatusAction: React.FC<ModalFlowStatusActionProps> = ({
  mode = 'add',
  onConfirm,
  handleClose,
  data,
  ...restProps
}) => {
  const [description, setDescription] = useState<string>(data.description);
  const descriptionRef = React.useRef<HTMLInputElement>(null);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<FormErrors | undefined>();

  useEffect(() => {
    if (descriptionRef.current) {
      descriptionRef.current.focus();
    }
  }, []);

  const handleConfirm = async (): Promise<void> => {
    const formErrors: FormErrors = {} as FormErrors;

    if (!description) {
      Object.assign(formErrors, { description: true, type: 'required' });
    }

    setErrors(formErrors);
    if (Object.keys(formErrors).length) {
      return;
    }

    try {
      if (onConfirm) {
        onConfirm({
          description,
        });
      }
      handleClose();
    } catch (err) {
      toast({
        description:
          err.response?.data?.message || 'Houve um erro ao criar o status!',
        status: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal {...restProps}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {mode === 'add' ? 'Nova Ação' : 'Editar Ação'}
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <FormControl marginTop="4" isInvalid={!!errors?.description}>
            <FormLabel>Descrição</FormLabel>

            <Input
              ref={descriptionRef}
              w="100%"
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleConfirm()}
            />
            <FormErrorMessage>Descrição é obrigatória</FormErrorMessage>
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button
            isLoading={loading}
            isDisabled={loading}
            colorScheme="green"
            onClick={handleConfirm}
          >
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalFlowStatusAction;
